import React from "react";
import PropTypes from "prop-types";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import List from "antd/lib/list";
import Tag from "antd/lib/tag";
import Icon from "antd/lib/icon";
import Button from "antd/lib/button";
import CompanyInvoicesAddModal from "../templates/company-invoices-add-modal";


class JobCreate extends React.Component {
    
    onJobCreate = ({ seller, invoice_files }) => {
        const requestId = (new Date().toJSON());
        this.props.createNewJob(requestId, seller, invoice_files);
    }

    retryJob = (request) => {
        this.props.createNewJob(request.id, request.seller, request.invoices);
    }

    openJob = (request) => {
        this.props.history.push(`/app/companies/invoices/${request.job.id}`);
    }

    
    render() {
        return (
            <Row>
                <Col span={12}>
                    <CompanyInvoicesAddModal 
                        modalSubmit={this.onJobCreate} 
                        getDealers={this.props.getDealers} 
                        dealers={this.props.dealers}
                        handleInvoiceForm={this.props.handleInvoiceForm}
                        selectedSeller={this.props.formSelectedSeller}
                    />
                </Col>
                <Col span={10}>
                    <List
                        header={"Disbursal Requests"}
                        dataSource={this.props.requests.toList()}
                        itemLayout={"vertical"}
                        renderItem={request => (
                            <List.Item 
                                key={request.id} 
                                extra={
                                    [
                                        !request.isProcessed() ? <Tag 
                                            key={"status-tag"} 
                                            color={request.isLoading() ? "#2db7f5" : request.isError() ? "#f50" : null}
                                        >
                                            {request.isLoading() ? <Icon type={"loading"} style={{ marginRight: "10px" }} /> : null }
                                            {request.getStage()}
                                        </Tag> : null,
                                        request.isProcessed() ? 
                                            <Button 
                                                key={"details-btn"} 
                                                size={"small"} 
                                                type={"link"} 
                                                onClick={() => this.openJob(request)}
                                            >
                                                View Details <Icon type={"arrow-right"} />
                                                
                                            </Button> 
                                            : null,
                                        request.isError() ? 
                                            <Button 
                                                key={"retry-btn"} 
                                                size={"small"} 
                                                type={"link"} 
                                                onClick={() => this.retryJob(request)}
                                            >
                                                Retry <Icon type={"redo"}/>
                                            </Button> 
                                            : null
                                    ]}
                            >
                                <List.Item.Meta 
                                    title={request.seller.name} 
                                    description={request.seller.gstin}
                                />
                                <div>
                                    {request.isJobCreated() ? 
                                        <div style={{width: "200px"}}>
                                            {`${request.totalParsedInvoices} out of ${request.totalInvoices()} Invoices`}
                                        </div> 
                                        : null
                                    }
                                </div>
                            </List.Item>
                        )}
                    />
                </Col>
                <Col>
                    {/* {existing job requests} */}
                </Col>
            </Row>
        );
    }
}

JobCreate.propTypes = {
    requests: PropTypes.object,
    createNewJob: PropTypes.func,
    history: PropTypes.object,
    getDealers : PropTypes.func,
    dealers : PropTypes.dealers,
    formSelectedSeller : PropTypes.object,
    handleInvoiceForm : PropTypes.func
};

export default JobCreate;


